import React from 'react'
import FlexContainer from '@components/common/FlexContainer'
import Input from '@components/common/form/Input'
import Dropdown from '@components/common/form/Dropdown'
import YSpacing from '@components/common/YSpacing'
import { Schedule } from '../types'
import { CYCLE_LENGTH_OPTIONS } from '../constants'

interface Props {
  schedule: Schedule
  onUpdate: (partial: Partial<Schedule>) => void
}

const ScheduleHeader: React.FC<Props> = ({ schedule, onUpdate }) => {
  return (
    <div>
      <FlexContainer flexDirection="column" width="100%">
        <Input
          label="Schedule Name"
          width="100%"
          type="text"
          value={schedule.name || ''}
          placeholder="Trial, Default, Summer etc"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onUpdate({ name: e.target.value || null })
          }
        />

        <YSpacing height="6px" />

        <Dropdown
          label="Cycle Length"
          width="100%"
          value={schedule.cycleLengthWeeks?.toString() ?? ''}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const val = e.target.value
            onUpdate({
              cycleLengthWeeks: val === '' ? null : parseInt(val, 10),
            })
          }}
        >
          {CYCLE_LENGTH_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Dropdown>

        <YSpacing height="6px" />

        {schedule.cycleLengthWeeks !== null &&
          schedule.cycleLengthWeeks > 1 && (
            <>
              <Input
                label="Cycle Anchor Date (defines Week 1)"
                width="100%"
                type="date"
                value={schedule.cycleAnchorDate}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onUpdate({ cycleAnchorDate: e.target.value })
                }
              />
              <YSpacing height="6px" />
            </>
          )}

        <FlexContainer width="100%" justifyContent="space-between">
          <Input
            label="Effective From"
            width="48%"
            type="date"
            value={schedule.effectiveFrom}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({ effectiveFrom: e.target.value })
            }
          />
          <Input
            label="Effective Until (blank = open-ended)"
            width="48%"
            type="date"
            value={schedule.effectiveUntil || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({
                effectiveUntil: e.target.value || null,
              })
            }
          />
        </FlexContainer>
      </FlexContainer>
    </div>
  )
}

export default ScheduleHeader
